import React from 'react'
import { ExperienceDetailsFragment } from '#src/generated/graphql'
import SellableMetaData from '#src/components/SellableMetaData'

interface ExperienceMetaDataProps {
  sellable: ExperienceDetailsFragment
}

/**
 * This is an experience meta data wrapper but is really only for yacht charters right now.
 * We can expand it as we add on new experience categories.
 */
const ExperienceMetaData: React.SFC<ExperienceMetaDataProps> = ({ sellable }) => {
  return (
    <SellableMetaData
      sellable={sellable}
      overrideTitle={`Charter a ${sellable.title} - Boat for Rent ${
        sellable.serviceLocation && sellable.serviceLocation.displayTitle
          ? `in ${sellable.serviceLocation.displayTitle}`
          : 'on Curated'
      }`}
      overrideDescription={
        sellable.descriptionText
          ? sellable.descriptionText
          : 'Curated is the modern, simple way to book a yacht for any occasion. Our chartering experts help you find the perfect boat and work with you to plan your ideal itinerary. Book with Curated and enjoy the experience of a lifetime.'
      }
    />
  )
}

export default ExperienceMetaData
